import React from 'react';
import BrowseTab from './BrowseTab';
import StructureTab from './StructureTab';
import SqlEditor from './Editor';
import DbUpdates from './DbUpdates';
import SearchTab from './SearchTab';
import ExportTab from './ExportTab';
import ImportTab from './ImportTab';
import '../css/ObjectsTab.css';
import InsertTab from './InsertTab';
import ImportCsvDataTab from './ImportCSVDataTab';

function ObjectTabs({ selectedObject, activeTab }) {
  if (!selectedObject  && activeTab !== 'sql') return <div className="tabs">No object selected.</div>;

  const tableName = selectedObject?.name || selectedObject;
  const objectType = selectedObject?.type || 'Table';

  return (
    <div className="container-fluid p-0">
      <div className="pb-2 mb-3 border-bottom d-flex align-items-center justify-content-between">
        <h4 className="m-0">
          {tableName}{' '}
          <small className="text-muted" style={{ fontSize: '0.75em' }}>
            ({objectType})
          </small>
        </h4>
      </div>

      <div className="tab-content">
        {activeTab === 'browse' && <BrowseTab table={tableName} />}
        {activeTab === 'structure' && <StructureTab table={tableName} />}
        {activeTab === 'sql' && <SqlEditor table={tableName} />}
        {activeTab === 'insert' && <InsertTab table={tableName} />}

        {activeTab === 'db_updates' && <DbUpdates />}
        {activeTab === 'search' && <SearchTab table={tableName} />}
        {activeTab === 'export' && <ExportTab table={tableName} />}
        {activeTab === 'import' && <ImportTab table={tableName} />}
         {activeTab === 'import-csv-data' && <ImportCsvDataTab table={tableName} />}
        
      </div>
    </div>
  );
}

export default ObjectTabs;
